import { render, staticRenderFns } from "./partIndex.vue?vue&type=template&id=a6d646da"
import script from "./partIndex.vue?vue&type=script&lang=js"
export * from "./partIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports